import { useLocation } from "react-router-dom";
export const parsePath = (path) => path.split('/').filter(s => s);
export const useQueryParams = () => new URLSearchParams(useLocation().search);
